"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";
import { Card, CardContent } from "@/components/ui/card";

interface Feature {
  title: string;
  description: string;
}

interface FeatureListCardsProps {
  title?: string;
  features: Feature[];
}

const FeatureListCards = ({ title, features }: FeatureListCardsProps) => {
  if (!features || features.length === 0) return null;

  return (
    <section className="py-24 px-6 bg-white">
      <div className="container max-w-6xl mx-auto">
        {title && (
          <BlurFade delay={0.1}>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground text-center mb-12">
              {title}
            </h2>
          </BlurFade>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, i) => (
            <BlurFade key={i} delay={0.15 + i * 0.06}>
              <Card className="border-0 bg-muted hover:shadow-md transition-all h-full">
                <CardContent className="p-6 space-y-4">
                  {/* Number badge */}
                  <div className="text-5xl font-bold text-primary/20 leading-none">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3 className="text-lg font-bold text-foreground">
                    {feature.title}
                  </h3>
                  <p className="text-foreground/60 leading-relaxed text-sm">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureListCards;
